import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { FiUser } from "react-icons/fi";

import Sidebar from "./Sidebar";
import Header from "./Header";
import SideDrawer from "./SideDrawer/SideDrawer";
import PortalProfilePage from "../pages/portal/PortalProfilePage";
import useAuth from "../hooks/useAuth";
import { UIProvider, useUI } from "../context/UIContext";
import styles from "./Layout.module.css";

/** Rama aplikacji: stałe menu boczne + nagłówek + przewijany obszar treści (układ z mPracownika). */
const LayoutShell = () => {
    const { isSidebarCollapsed } = useUI();
    const { user } = useAuth();

    // „Moje dane" wizytatora — wysuwane okno dostepne z KAZDEGO miejsca aplikacji
    // (pozycja menu i przycisk pulpitu wysylaja zdarzenie bp:open-profile).
    const [profileOpen, setProfileOpen] = useState(false);
    useEffect(() => {
        const open = () => setProfileOpen(true);
        window.addEventListener("bp:open-profile", open);
        return () => window.removeEventListener("bp:open-profile", open);
    }, []);

    return (
        <div className={styles.layout}>
            {/* WCAG: nawigacja klawiaturą — pierwszy Tab pozwala przeskoczyć menu boczne
                wprost do treści (klasa globalna .skip-to-content, wzorzec mPracownika). */}
            <a className="skip-to-content" href="#main-content">
                Przejdź do treści
            </a>
            <Sidebar />
            <div
                className={`${styles.mainContent}${isSidebarCollapsed ? ` ${styles.collapsed}` : ""}`}
                id="main-content"
            >
                <Header />
                <div className={styles.pageContent}>
                    <div className={styles.pageBody}>
                        <Outlet />
                    </div>
                </div>
            </div>

            {Boolean(user?.isPortalAccount) && (
                <SideDrawer
                    isOpen={profileOpen}
                    onClose={() => setProfileOpen(false)}
                    title="Moje dane"
                    subtitle="Dane konta i ich edycja"
                    icon={<FiUser size={18} />}
                    width="860px"
                >
                    {profileOpen && <PortalProfilePage embedded />}
                </SideDrawer>
            )}
        </div>
    );
};

/* Stan powłoki (zwinięcie menu, drawer mobilny) żyje TYLKO tutaj — portal publiczny
   (`/wniosek/...`) renderuje się poza Layoutem i tego kontekstu nie potrzebuje. */
const Layout = () => (
    <UIProvider>
        <LayoutShell />
    </UIProvider>
);

export default Layout;
